import * as Constants from './constants'

const initialState = {
  questionsLoading: false,
  filterLoading: false,
  addLoading: false,
  deleteLoading: false,
  questions: [],
}

const reducer = function questionReducer (state = initialState, action) {
  switch (action.type) {
    case Constants.QUESTION_REQUEST:
      return {
        ...state,
        questionsLoading: true,
        messages: [{
          body: 'Fetching questions...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.QUESTION_SUCCESS:
      return {
        ...state,
        questions: action.data.data,
        questionsLoading: false,
        messages: [{
          body: action.data.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.QUESTION_ERROR:
      return {
        ...state,
        questionsLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.FILTER_REQUEST:
      return {
        ...state,
        filterLoading: true,
        messages: [{
          body: 'Fetching filters...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.FILTER_SUCCESS:
      return {
        ...state,
        filter: action.data.data,
        filterLoading: false,
        messages: [{
          body: action.data.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.FILTER_ERROR:
      return {
        ...state,
        filterLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.DELETE_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        messages: [{
          body: 'Deleting Question...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.DELETE_SUCCESS:
      return {
        ...state,
        delete: action.result,
        deleteLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.DELETE_ERROR:
      return {
        ...state,
        delete: action.error,
        deleteLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.CLEAR_DELETE_REQUEST:
      return {
        ...state,
        delete: undefined,
        deleteLoading: false,
        messages: [],
        errors: [],
      }

    default:
      return state
  }
}

export default reducer
